import { DirectiveOptions, DirectiveFunction, VNodeDirective, VNode } from "vue";

export class InitDirective implements DirectiveOptions {

    public bind?: DirectiveFunction = this.onBind;

    private onBind(el: HTMLElement, binding: VNodeDirective, vnode: VNode, oldVnode: VNode): void {

        let arg = binding.arg.split('-').map((arg, index) => {
            return (index > 0) ? arg[0].toUpperCase() + arg.substring(1) : arg;
        }).join('');

        return (vnode.context || {})[arg] = binding.value;
    }
}


// WEBPACK FOOTER //
// ./www/js/Directives/InitDirective.ts